import ServiceNavbar from '../services/shared/ServiceNavbar';
import Footer from '../home/components/Footer';
import AboutHero from './components/AboutHero';
import CompanyStory from './components/CompanyStory';
import ValuesSection from './components/ValuesSection';
import StandardsSection from './components/StandardsSection';
import AboutCTA from './components/AboutCTA';

const AboutPage = () => (
  <div className="min-h-screen bg-[#0A1628] font-sans">
    <ServiceNavbar />
    <main>
      <AboutHero />
      <CompanyStory />
      <ValuesSection />
      <StandardsSection />
      <AboutCTA />
    </main>
    <Footer />
  </div>
);

export default AboutPage;
